import api from '@/api'

export function salvarAutomacao(url, method, payload) {
  if (method === 'put') {
    return api.put(url, payload)
  }

  return api.post(url, payload)
}

export function gerarAutomacaoIa(url, pedido) {
  return api.post(url, { pedido: pedido }, { timeout: 100000 })
}
